import './App.css';
import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import About from './Components/About';
import Footer from './Components/Footer';
import Header from './Components/Header';
import Hero from './Components/Hero';
import PopularFoods from './Components/PopularFoods';
import Trending from './Components/Trending';
import Lenis from 'lenis';

function App() {
    useEffect(() => {
        AOS.init({
            duration: 1000,
            offset: 100,
        });
    }, []);

    useEffect(() => {
        const lenis = new Lenis();

        function raf(time) {
            lenis.raf(time);
            requestAnimationFrame(raf);
        }
        requestAnimationFrame(raf);
    }, []);

    return (
        <>
            <Header />
            <Hero />
            <About />
            <PopularFoods />
            <Trending />
            <Footer />
        </>
    );
}

export default App;
